import React from 'react';

interface QualityAnalysisSuccessProps {
  qualityDecision: 'ACCEPTE' | 'ACCEPTE_RESERVE' | 'REFUSE';
  onContinue: () => void;
  onFinish: () => void;
  className?: string;
}

const QualityAnalysisSuccess: React.FC<QualityAnalysisSuccessProps> = ({
  qualityDecision,
  onContinue,
  onFinish,
  className = ''
}) => {
  const getDecisionInfo = () => {
    switch (qualityDecision) {
      case 'ACCEPTE':
        return {
          title: 'Produit Accepté',
          message: 'Le produit a été accepté et peut continuer vers la pesée tare.',
          icon: 'fas fa-check-circle',
          color: 'text-green-600',
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200'
        };
      case 'ACCEPTE_RESERVE':
        return {
          title: 'Produit Accepté avec Réserve',
          message: 'Le produit a été accepté avec des réserves. Il peut continuer vers la pesée tare.',
          icon: 'fas fa-exclamation-triangle',
          color: 'text-yellow-600',
          bgColor: 'bg-yellow-50',
          borderColor: 'border-yellow-200'
        };
      case 'REFUSE':
        return {
          title: 'Produit Refusé',
          message: 'Le produit a été refusé. La pesée sera marquée comme refoulée.',
          icon: 'fas fa-times-circle',
          color: 'text-red-600',
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200'
        };
      default:
        return {
          title: 'Analyse Terminée',
          message: 'L\'analyse qualité a été enregistrée avec succès.',
          icon: 'fas fa-check',
          color: 'text-blue-600',
          bgColor: 'bg-blue-50',
          borderColor: 'border-blue-200'
        };
    }
  };

  const decisionInfo = getDecisionInfo();

  return (
    <div className={`bg-white rounded-xl shadow-sm p-8 ${className}`}>
      <div className={`${decisionInfo.bgColor} ${decisionInfo.borderColor} border rounded-lg p-6 text-center`}>
        {/* Icône de succès */}
        <div className="mb-4">
          <i className={`${decisionInfo.icon} text-6xl ${decisionInfo.color}`}></i>
        </div>

        {/* Titre */}
        <h2 className={`text-2xl font-bold ${decisionInfo.color} mb-3`}>
          {decisionInfo.title}
        </h2>

        {/* Message */}
        <p className="text-gray-700 text-lg mb-6">
          {decisionInfo.message}
        </p>

        {/* Boutons d'action */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {qualityDecision !== 'REFUSE' && (
            <button
              onClick={onContinue}
              className="px-8 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
            >
              <i className="fas fa-arrow-right mr-2"></i>
              Continuer vers la pesée tare
            </button>
          )}
          
          <button
            onClick={onFinish}
            className={`px-8 py-3 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
              qualityDecision === 'REFUSE'
                ? 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500'
                : 'bg-gray-600 hover:bg-gray-700 text-white focus:ring-gray-500'
            }`}
          >
            <i className="fas fa-home mr-2"></i>
            {qualityDecision === 'REFUSE' ? 'Retour au tableau de bord' : 'Terminer et retourner au tableau de bord'}
          </button>
        </div>

        {/* Informations supplémentaires */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            L'analyse qualité a été enregistrée dans le système et le statut de la pesée a été mis à jour.
          </p>
        </div>
      </div>
    </div>
  );
};

export default QualityAnalysisSuccess;
